// @flow

import type {
  QueryExecutionIdAction,
  QueryExecutionIdState
} from 'stores/flow-type/analytics-query-execution-id.type';

import { UPDATE_EXECUTION_ID } from 'stores/flow-type/analytics-query-execution-id.type';

import { saveExecutionId } from 'src/helpers/analytics-query-execution-id-helper';

const initialState: QueryExecutionIdState = {
  list: []
};

const multiLevelReducers = (
  state: QueryExecutionIdState = initialState,
  action: QueryExecutionIdAction
) => {
  switch (action.type) {
    case UPDATE_EXECUTION_ID: {
      let { list } = state;

      // Search and update execution id
      const updatedList = saveExecutionId(action.payload.data, list);

      return {
        ...state,
        list: updatedList
      };
    }
    default:
      return state;
  }
};

export default multiLevelReducers;
